<template>
    <div class="status-list-components">
        <div class="borad-operate-right">
            <div @click="gotoList" class="visitor-top flex justify-between items-center">
                <div>
                    <div class="visitor-title">{{ $t('Board.Appointment.title') }}</div>
                    <div class="visitor-desc">{{ $t('Board.Appointment.no') }}{{ none }} / {{ $t('Board.Appointment.all') }}{{ total }}</div>
                </div>
                <div class="iconfont icon-fitness-jiantouyou more"></div>
            </div>
            <!-- 无数据状态 -->
            <div v-if="!list.length" class="visitor-content-none flex flex-column items-center">
                <div class="iconfont icon-fitness-meiyou-biaoqing none-data"></div>
                <div class="no-visitor">{{ $t('Board.Appointment.none') }}</div>
            </div>
            <!-- 有数据状态 -->
            <div v-if="list.length" class="visitor-content-have">
                <div class="visitor-list flex items-start" v-for="(item, index) in list" :key="index">
                    <p class="time">{{ item.appointedAt }}</p>
                    <div class="portrait relative">
                        <div
                            v-if="item.clientAvatar"
                            class="status-list-avatar"
                            :style="`background-image: url(${item.clientAvatar})`">
                        </div>
                        <img v-else src="../../../assets/images/saas-no-avatar.png" alt="100*100">
                        <label
                            v-if="Number(item.clientTypeCode) === 1"
                            class="potential"
                        >{{ $t("Board.Appointment.potential") }}</label>
                        <label v-else class="potential">{{ $t("Board.Appointment.formal") }}</label>
                    </div>
                    <div  class="name">{{ item.clientName }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'status-list',
    components: {
    },
    data() {
        return {
            list: [],
            none: 0,
            total: 0,
        };
    },
    methods: {
        fetchData(id) {
            API.get('reception/appointment/dashboard', {
                params: {
                    storeId: id,
                },
            }).then(res => {
                this.list = res.appointments;
                this.none = res.upcomingAmount;
                this.total = res.totalAmount;
            });
        },
        gotoList() {
            if (!this.$$filterPermission('前台-来访预约登记-来访预约出入场登记')) {
                return this.$router.push('/403');
            }
            this.$router.push({
                name: 'Reception',
                query: {
                    activeName: 'second',
                },
            });
        },
    },
};
</script>

<style lang="scss">
.status-list-components {
    width: 33%;
    height: 490px;
    margin-right: 1%;
}
.borad-operate-right {
    width: 100%;
    height: 100%;
    padding: 20px 25px;
    background: #fff;
    border-radius: 7px;
}
.visitor-title {
    font-size: 20px;
    color: #212121;
    font-weight: 400;
    margin-bottom: 4px;
}
.visitor-desc {
    font-size: 14px;
    color: #8b8b8b;
}
.visitor-content-none {
    margin-top: 120px;

    .iconfont.none-data {
        font-size: 50px;
        color: #d8d8d8;
    }
}
.no-visitor {
    font-size: 15px;
    color: #999;
    margin-top: 20px;
}
.visitor-top {
    cursor: pointer;
}
.visitor-content-have {
    margin-top: 10px;
}
.visitor-list {
    width: calc(100% + 20px);
    padding: 15px 10px;
    border-radius: 8px;
    position: relative;
    left: -10px;

    &:hover {
        box-shadow: 0 0 15px #77cef7;
        transition: box-shadow .5s;
    }

    .time {
        color: #8b8b8b;
        float: left;
        width: 50px;
        font-size: 13px;
    }
    .portrait {
        margin-right: 15px;
        img {
            width: 50px;
            height: 50px;
            border-radius: 100%;
        }
        .potential {
            position: absolute;
            width: 40px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            border-radius: 9px;
            color: #fff;
            left: 50%;
            bottom: -8px;
            margin-left: -20px;
            background: #6ecbf6;
        }
    }
    .name {
        font-size: 18px;
        color: #212121;
    }
    .rank {
        width: 30px;
        margin-right: 30px;
        text-align: center;

        .iconfont {
            color: #f2bd03;
            font-size: 25px;
        }
    }
    &:nth-child(2) {
        .iconfont {
            color: #b7b7b7;
        }
    }
    &:nth-child(3) {
        .iconfont {
            color: #f19a5b;
        }
    }
    .txt {
        color: #949494;
        font-size: 14px;
    }
    &:nth-child(4),
    &:nth-child(5) {
        .txt {
            font-size: 24px;
            color: #949494;
            font-style: italic;
        }
    }
}
</style>
